<template>
    <div class="toast-views-container">
        <div v-for="toast in displayedToasts" :key="toast.id" :class="['toast-view', `toast-${toast.color}`]">
            <div :class="['toast-type-indicator', `toast-${toast.color}`]"></div>
            <h2 v-show="toast.title !== ''">{{ toast.title }}</h2>
            <p v-html="toast.text"></p>
            <hr v-show="toast.timeout <= 0">
            <p v-show="toast.timeout <= 0" class="w3-right-align">
                <button class="w3-button w3-small">Close</button>
            </p>
        </div>
    </div>
</template>

<style scoped>
.toast-views-container {
    position: absolute;
    z-index: 99;
    top: 20px;
    left: 30%;
    right: 30%;
    margin: auto;
}

.toast-view {
    background: rgba(255, 255, 255);
    padding: 10px;
    border: 1px solid;
    border-radius: 5px;
    color: #000;
    box-shadow: 0 0 5px #00000099;
    margin-bottom: 10px;
}
.toast-view hr {
    border-color: #111812;
    margin: 5px 0 5px 0;
}
.toast-view p {
    font-size: .9em;
    margin: 0;
}

.toast-type-indicator {
    width: 16px;
    height: 16px;
    background: #000;
    float: right;
}
.toast-type-indicator.toast-red {
    background: #b30000;
}
.toast-type-indicator.toast-yellow {
    background: #b3a700;
}
.toast-type-indicator.toast-green {
    background: #00b34a;
}
.toast-type-indicator.toast-blue {
    background: #0012b3;
}
</style>

<script>
import EventBus from '@/utils/EventBus'

export default {
    data () {
        return {
            nextToastId: 1,
            toastColors: ['red', 'blue', 'yellow', 'green'],
            toasts: [],
            timeouts: {}
        }
    },

    computed: {
        displayedToasts: function () {
            return this.toasts.slice(0, 2)
        }
    },

    mounted () {
        EventBus.$on('toast', this.addToast)
    },

    destroyed () {
        EventBus.$off('toast', this.addToast)
    },

    methods: {
        addToast (event) {
            let self = this

            if (!(event instanceof Object)) {
                console.error('Toast message to be displayed must be an object.')
                return
            }
            if (typeof event.text !== 'string' || event.text === '') {
                return
            }

            let toast = {
                id: self.nextToastId++,
                title: typeof event.title === 'string' ? event.title : '',
                text: event.text,
                color: typeof event.color === 'string' && self.toastColors.indexOf(event.color) > -1 ? event.color : 'blue',
                timeout: typeof event.timeout === 'number' && event.timeout > 0 ? event.timeout : 2500
            }
            self.toasts.push(toast)

            if (toast.timeout > 0) {
                self.timeouts[toast.id] = window.setTimeout(() => {
                    delete(self.timeouts[toast.id])
                    self.toasts = self.toasts.filter(it => it.id !== toast.id)
                }, toast.timeout)
            }
        }
    }
}
</script>
